import './side-menu.scss'

import { defineComponent } from 'vue';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';

export const SideMenu = defineComponent({
    mixins: [reactiveVueMixin],
    props: {
        toggleSideMenuTopic: { type: String, required: true },
        forceCloseMenuTopic: { type: String, required: true },
    },
    template: require('./side-menu.html'),
    data() {
        return {
            isDisplayed: false,
        }
    },
    mounted() {
        this.subscribeToBus(this.toggleSideMenuTopic, message => this.toggleMenu(message))
        this.subscribeToBus(this.forceCloseMenuTopic, message => this.isDisplayed = false)
    },
    methods: {
        toggleMenu(message: any) {
            this.isDisplayed = !this.isDisplayed;
        },
    },
})
